import { createContext } from "react";

interface APIContextType {
  domain: string;
  token?: string | null;
  setToken: (token: string) => void;
  clearToken: () => void;
}

export const APIContext = createContext<APIContextType>({
  domain: "",
  setToken(): void {
    throw new Error(
      "setToken was called but there was no provider for APIContext. Wrap the component in an APIContext provider."
    );
  },
  clearToken(): void {
    throw new Error(
      "clearToken was called but there was no provider for APIContext. Wrap the component in an APIContext provider."
    );
  },
});

interface Props extends APIContextType {
  children: React.ReactNode;
}

export const APIProvider = ({ children, ...providerValues }: Props) => {
  return (
    <APIContext.Provider value={providerValues}>{children}</APIContext.Provider>
  );
};
